"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function stringifyPixel(p) {
  return typeof p === 'number' && p !== 0 ? p + 'px' : "" + p;
}

exports.createPixelString = function () {
  var padding = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    padding[_i] = arguments[_i];
  }

  return padding.map(stringifyPixel).join(' ');
};